/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParameterDto
 */
export interface ParameterDto {
    /**
     * 
     * @type {string}
     * @memberof ParameterDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterDto
     */
    paramId?: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterDto
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterDto
     */
    usage?: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterDto
     */
    constraints?: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterDto
     */
    guidelines?: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterDto
     */
    values?: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterDto
     */
    selectType?: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterDto
     */
    controlId?: string;
    /**
     * 
     * @type {string}
     * @memberof ParameterDto
     */
    controlName?: string;
    /**
     * 
     * @type {Date}
     * @memberof ParameterDto
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ParameterDto
     */
    updated?: Date;
}

/**
 * Check if a given object implements the ParameterDto interface.
 */
export function instanceOfParameterDto(value: object): value is ParameterDto {
    return true;
}

export function ParameterDtoFromJSON(json: any): ParameterDto {
    return ParameterDtoFromJSONTyped(json, false);
}

export function ParameterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParameterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'paramId': json['paramId'] == null ? undefined : json['paramId'],
        'label': json['label'] == null ? undefined : json['label'],
        'usage': json['usage'] == null ? undefined : json['usage'],
        'constraints': json['constraints'] == null ? undefined : json['constraints'],
        'guidelines': json['guidelines'] == null ? undefined : json['guidelines'],
        'values': json['values'] == null ? undefined : json['values'],
        'selectType': json['selectType'] == null ? undefined : json['selectType'],
        'controlId': json['controlId'] == null ? undefined : json['controlId'],
        'controlName': json['controlName'] == null ? undefined : json['controlName'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'updated': json['updated'] == null ? undefined : (new Date(json['updated'])),
    };
}

export function ParameterDtoToJSON(json: any): ParameterDto {
    return ParameterDtoToJSONTyped(json, false);
}

export function ParameterDtoToJSONTyped(value?: ParameterDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'paramId': value['paramId'],
        'label': value['label'],
        'usage': value['usage'],
        'constraints': value['constraints'],
        'guidelines': value['guidelines'],
        'values': value['values'],
        'selectType': value['selectType'],
        'controlId': value['controlId'],
        'controlName': value['controlName'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'updated': value['updated'] == null ? undefined : ((value['updated']).toISOString()),
    };
}

